export const GooglePlacesFieldType = {
  ADDRESS_COMPONENTS: 'address_components',
  FORMATTED_ADDRESS: 'formatted_address'
};
